module.exports = "<app-toasts aria-live=\"polite\" aria-atomic=\"true\"></app-toasts>\r\n"